'use server';

import request from '../../../api/request';
import { actionKitImpFunction } from '../../../components/ozmoit/common/action-kit-imp';
import {
  PaginationQueryDto,
  PaginationRequestType,
} from '../../../types/paginationRequestType';
import {
  StudentWarningsGroupType,
  StudentWarningsSummaryDataParams,
  StudentWarningsSummaryDetailsParams,
  StudentWarningsSummaryDetailsResponse,
  StudentWarningsSummaryFormData,
  StudentWarningsSummaryFormDetailsResponse,
  StudentWarningsSummaryRow,
} from '../types';

const getFormDataAction = actionKitImpFunction(async () => {
  const response = await request<StudentWarningsSummaryFormData>(
    'maintainers-portal/student-warnings/form/summary',
  );
  if (response.error) {
    throw new Error('Error fetching student warnings form data');
  }
  return response.data;
});

const getFormDetailsAction = actionKitImpFunction(async () => {
  const response = await request<StudentWarningsSummaryFormDetailsResponse>(
    'maintainers-portal/student-warnings/form/details',
  );
  if (response.error) {
    throw new Error('Error fetching student data');
  }
  return response.data;
});

const getSummaryPaginatedDataAction = actionKitImpFunction(
  async ({
    page,
    ...params
  }: PaginationQueryDto<StudentWarningsSummaryDataParams>): Promise<
    PaginationRequestType<StudentWarningsSummaryRow>
  > => {
    if (!params?.periodId || !params?.schoolId || !params?.year) {
      return {
        data: [],
        total: 0,
        total_pages: 0,
      };
    }
    const response = await request<
      PaginationRequestType<StudentWarningsSummaryRow>
    >('maintainers-portal/student-warnings/summary', {
      params: {
        ...params,
        page: Math.max(page - 1, 0),
      },
    });
    if (response.error) {
      throw new Error('Error fetching student warnings summary data');
    }
    return response.data;
  },
);

const getDetailsAction = actionKitImpFunction(
  async ({
    studyPlanEnrollmentId,
    periodId,
    year,
    warningGroupType,
  }: StudentWarningsSummaryDetailsParams) => {
    const response = await request<StudentWarningsSummaryDetailsResponse>(
      `maintainers-portal/student-warnings/summary/details/${studyPlanEnrollmentId}/${periodId}/${year}/${warningGroupType}`,
    );
    if (response.error) {
      throw new Error('Error fetching student data');
    }
    return response.data;
  },
);

const createWarningRecord = actionKitImpFunction(
  async (type: StudentWarningsGroupType, data: Record<string, any>) => {
    const response = await request<void>(
      `maintainers-portal/student-warnings/${type}/create`,
      {
        method: 'POST',
        data,
      },
    );
    if (response.error) {
      throw new Error('Error saving student data');
    }
  },
);

export {
  getFormDataAction,
  getFormDetailsAction,
  getSummaryPaginatedDataAction,
  getDetailsAction,
  createWarningRecord,
};
